import PrimaryLayout from "./layouts/PrimaryLayout";

export default [
  //{ path: "/device", name: "device", component: MainLayout, auth: true },
  { path: "/index", name: "index", component: PrimaryLayout, auth: false },
]